// extracted by mini-css-extract-plugin
module.exports = {"container":"Rating_container__J9v6i","starsContainer":"Rating_starsContainer__ZK_n2"};